export default "__VITE_ASSET__CTvYSUFo__"